/**
 * Normalise les offres chargées (localStorage / anciennes versions) avec les champs pack / abo du spec PaymentsTab.
 */

/**
 * @param {object} p
 * @returns {object}
 */
export function migrateProduct(p) {
  if (!p || typeof p !== "object") return p;
  const next = { ...p };
  if (next.type === "program") {
    next.type = "programme";
  }
  if (next.type === "programme") {
    const cnt = Math.max(0, Number(next.sessions?.count) || 0);
    if (cnt > 0 && next.pricing?.amount != null) {
      next.pricing = {
        ...next.pricing,
        perSession: Math.round((Number(next.pricing.amount) / cnt) * 100) / 100,
      };
    }
    if (next.durationWeeks == null && next.sessions?.validityDays != null) {
      next.durationWeeks = Math.max(1, Math.round(Number(next.sessions.validityDays) / 7));
    }
    if (next.durationWeeks == null) next.durationWeeks = 12;
    next.paymentSchedule = next.paymentSchedule || next.payment_schedule || "once";
  }
  if (next.type === "pack") {
    next.sessions = {
      ...next.sessions,
      packValidityStart: next.sessions?.packValidityStart === "purchase" ? "purchase" : "first_session",
    };
  }
  if (next.type === "subscription") {
    next.subscription = {
      maintainByDefaultOnStandby: next.subscription?.maintainByDefaultOnStandby === true,
      standbyBillingMode:
        next.subscription?.standbyBillingMode === "prorata_days" ? "prorata_days" : "full_month",
    };
  }
  return next;
}
